export const IsPublicOrder = (details: {
  isPublished: boolean;
  taxiCorporationUuid: string | null;
}) => {
  const { isPublished, taxiCorporationUuid } = details;

  return taxiCorporationUuid === null || !!isPublished;
};
